export interface InstallationInstructions {
  mai: string[];
  lease: string[];
}

export function installationInstructionsModelFactory(json?: any): InstallationInstructions {
  json = json || {};

  return {
    mai: json.mai || [],
    lease: json.lease || [],
  };
}
